import { cva, VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  [
    'flex h-[26px] w-[26px] cursor-pointer items-center justify-center rounded-full',
    'typo-label1 font-medium text-gray-400',
  ],
  {
    variants: {
      mode: {
        light: '',
        dark: '',
      },
      selected: {
        true: 'transition-none',
        false: '',
      },
      disabled: {
        true: 'cursor-default text-gray-400',
        false: '',
      },
    },

    compoundVariants: [
      {
        mode: 'light',
        selected: true,
        className: 'text-black!',
      },
      {
        mode: 'dark',
        selected: true,
        className: 'text-white!',
      },
      {
        mode: 'light',
        disabled: false,
        selected: false,
        className:
          'hover:bg-white hover:text-black hover:transition-[color_250ms_cubic-bezier(0.4,0,0.2,1)_0ms]',
      },
      {
        mode: 'dark',
        disabled: false,
        selected: false,
        className:
          'hover:bg-gray-50 hover:transition-[color_250ms_cubic-bezier(0.4,0,0.2,1)_0ms]',
      },
    ],
  },
)

export type ButtonVariantsProps = VariantProps<typeof buttonVariants>
